<template>
	<fragment>
		<p-panel-properties-group title="Data">
			<p-property-tile title="Text">
				<v-text-field box single-line hide-details v-model="value.data.text"></v-text-field>
			</p-property-tile>

			<!-- Styles -->
			<p-property-tile class="mb-4" title="Styles">
				<DialogButtonStyle :value="value" :state="state">
					<template v-slot:activator="{ open }">
						<p-panel-button text="Edit" icon="mdi-palette-outline" tooltip="Edit button format" @click="open" />
					</template>
				</DialogButtonStyle>
			</p-property-tile>

			<!-- Icon selector -->
			<p-property-tile title="Icon">
				<icon-selector :selectedIcon="value.data.icon" @icon-selected="value.data.icon = $event">
					<template v-slot:activator="{ open }">
						<p-panel-button text="Select icon" tooltip="Select icon" @click="open" />
					</template>
				</icon-selector>
			</p-property-tile>

			<!-- Icon visibility -->
			<p-property-tile icon="mdi-eye" title="Visibility">
				<v-switch style="justify-content: flex-end" v-model="isIconVisible" hide-details @change="onChangeIconVisibility"/>
			</p-property-tile>

		</p-panel-properties-group>
	</fragment>
</template>

<script>
import PPanelPropertiesGroup from '../_components/utils/PPanelPropertiesGroup.vue';
import PPanelProperties from '../_components/utils/PPanelProperties.vue';
import PPropertyTile from '../_components/utils/PPropertyTile.vue';
import PPanelButton from '../_components/utils/PPanelButton.vue';
import DialogButtonStyle from './DialogButtonStyle.vue';
import { Fragment } from 'vue-fragment';
import IconSelector from '../../components/icon-selection/IconSelector.vue';
import materialIcons from '../../components/icon-selection/materialIcons';
export default {
	props: ['value', 'state'],
	data() {
		return {
			lastSelectedIcon: null,
			isIconVisible: false
		};
	},
	watch:{
		'value.data.icon': {
			immediate: true,
			handler(newValue) {
				if (!newValue || newValue === 'none') {
					this.isIconVisible = false;
					return;
				}
				this.isIconVisible = true;
				this.lastSelectedIcon = newValue;
			}
		}
	},
	components: {
		IconSelector,
		Fragment,
		PPanelPropertiesGroup,
		PPanelProperties,
		PPanelButton,
		PPropertyTile,
		DialogButtonStyle
	},
	methods: {
		onChangeIconVisibility(isIconVisible) {
			if (isIconVisible) {
				const defaultIcon = materialIcons[0];
				this.value.data.icon = this.lastSelectedIcon || defaultIcon;
			} else {
				this.value.data.icon = null;
			}
		}
	}
};
</script>
